import { HttpHeaders } from "@angular/common/http";
import { KeyValuePair } from "./key-value-pair";

export class HttpRequestConstants {

    public static getHttpOptionsForRequest(params?: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            params: {}
        };

        if(params) {
            httpOptions.params = params;
        }

        return httpOptions;
    }

    public static getHttpOptionsForImportRequest(headers?: KeyValuePair[], params?: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'reportProgress': 'true',
                'observe': 'events'
            }),
            params: {}
        };

        if(headers) {
            headers.forEach(x => {
                httpOptions.headers.append(x.key, x.value);
            })
        }

        if(params) {
            httpOptions.params = params;
        }

        return httpOptions;
    }

    public static getHttpOptionsForFileDownloadRequest(params?: any) {
        const httpOptions = {
            releaseType: 'blob',
            params: {}
        };

        if(params) {
            httpOptions.params = params;
        }

        return httpOptions;
    }
}